import React from 'react';
import { Props } from '../types';

export const RocheLeadText = ({
  blok,
  slot,
}: Props): JSX.Element => (
  <roche-lead-text slot={slot}>
    {blok.slotted_content}
  </roche-lead-text>
);
